export function getLast<T>(array: T[]): T {
  return array[array.length - 1];
}
